/* @flow */

import React from 'react';

import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';

import PageSubTitleViewComponent from 'components/pageTitle/subTitle';
import TwoFactorSetupComponent from './index';

import NotificationHelper from 'lib/notifications';
import { history } from 'store/index';
import { PROTECTED_PROFILE } from 'constants/pageRoutes';

export default function TwoFactorSetupPage() {

  const onComplete = () => {
    NotificationHelper.createNotification(NotificationHelper.TYPE_SUCCESS, 'notifications.2fa.success');
    history.push(PROTECTED_PROFILE);
  };

  const onCancel = () => history.push(PROTECTED_PROFILE);

  return (
    <Paper elevation={0}>
      <Box p={5}>
        <PageSubTitleViewComponent id="twofactor.title" />
        <Box mt={3}>
          <TwoFactorSetupComponent onComplete={onComplete} onCancel={onCancel} />
        </Box>
      </Box>
    </Paper>
  );
}
